import React from "react";
import MetaTitle from "~/components/Shared/MetaTitle";
import { isMobile, isBrowser, isTablet } from 'react-device-detect';
import DesktopContent from "./DesktopContent";
import MobileContent from "./MobileContent";

const Index = () => {

  return <React.Fragment>
    <MetaTitle>Document Signature</MetaTitle>
    {/* Tablet View */}
    {isTablet && <MobileContent />}
    {/* Browser and not Tablet View */}
    {isBrowser && !isTablet && <DesktopContent />}
    {/* Mobile and not Tablet View */}
    {isMobile && !isTablet && <MobileContent />}
  </React.Fragment>
}

export default Index;
